/* tslint:disable */
/* eslint-disable */
export enum WorkAiServiceAuthHeaderEnum {
  Bearer = 'bearer',
  ApiKey = 'apiKey'
}
